<template>
  <div>
    <component :is="getCurrentComponent()" dev v-bind="devData" />
  </div>
</template>

<script>
import "./init.js";
import { state, contexts, componentList, getCurrentComponent } from "@/developing/dev-data.js";
import { loadComponents } from "@/developing/utils/modular";
// import DevEB from "./event-bus";

const components = loadComponents(componentList, contexts.stages);


export default {
  components,
  data() {
    return {
      contexts,
      components,
      componentList,
      flatmap: [],
      localData: state,
      devData: state.devData
    }
  },
  watch: {
    "currentStage" (stage) {
      if (stage === "development") {
        this.dev = true;
        return;
      }
      this.dev = false;
    }
  },
  methods: {
    getCurrentComponent,
  }
}

</script>
